globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Websites = appCustomerSpace.Modals.Websites || {};

appCustomerSpace.Modals.Websites.OrderFaqQuestions = (function(superClass) {

  utils.extend(OrderFaqQuestions, superClass);

  function OrderFaqQuestions() {
    OrderFaqQuestions.__super__.constructor.apply(this, arguments);
    this.initSortable();
  }

  $.extend(OrderFaqQuestions.prototype, {
    initSortable: function() {
      var updatePlaceholder = function(e, ui) {
        ui.placeholder.css({
          visibility: 'visible',
          height: ui.item.outerHeight()
        });
      };

      var updatePositions = function() {
        $('.sortable-questions .card').each(function(index) {
          $(this).find('.question-position').val(index + 1);
        });
      };

      var options = {
        items: '> .card',
        tolerance: 'pointer',
        handle: '.drag-handle',
        start: updatePlaceholder,
        stop: updatePositions
      };

      this.$html.find('.sortable-questions').sortable(options);
    },
    callbackSuccess: function(data, successMsg) {
      if (data == null) {
        data = {};
      }
      if (data.response) {
        window.location = data.redirect_url;
      }
    }
  });

  return OrderFaqQuestions;

})(appCustomerSpace.Modal);
